'use strict';

import { companyUnity } from '../../modules/select';
import { lightningOneValidate } from '../../modules/validator/pages/lightningOne';

export const lightningOne = () => {
  lightningOneValidate();
  companyUnity();
};
